import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import Close_icon from '../../images/icons/CmDashIcons/Close_icon.svg';
import smileyEmoji from '../../images/icons/CmDashIcons/smileyEmoji.png';
import styles from './Comment.module.css';
import CommonTextArea from './CommonTextArea';
import useOutsideClick from '../../components/Dashboard-res/CommonComponent/useOutsideClick';
import CircularProgress from '@material-ui/core/CircularProgress';

import {
  commentsPostApi,
  commentGetApi,
  commentDeleteApi
} from '../../common/constants/api';
import { JSON, setTimeout } from 'window-or-global';
const { styleScroll, commentBox } = styles;

function CommonComment({ styleCommentBox, passAnyDocId }) {
  const [showCommentBox, setShowCommentBox] = useState(false);
  const [textVal, setTextVal] = useState('');
  const [commentData, setCommentData] = useState({
    isFetching: false,
    isFetched: false,
    failure: false,
    data: []
  });

  const [postData, setPostData] = useState({
    isFetching: false,
    isFetched: false,
    failure: false,
    data: []
  });

  const commentContainerRef = useRef(null);
  const forScrollRef = useRef(null);

  const isClickedOutside = useOutsideClick(commentContainerRef);
  const { data, failure, isFetching } = commentData;
  const {
    failure: isFailureAddingPost,
    isFetching: isFetchingAddPost
  } = postData;

  useEffect(() => {
    if (isClickedOutside) {
      setShowCommentBox(false);
    }
  }, [isClickedOutside]);

  //////////testing api calls
  async function postApi(passText) {
    setPostData({
      ...postData,
      isFetching: true
    });
    const resCommentId = await commentsPostApi(passAnyDocId, passText).catch(
      err => {
        setPostData({
          ...postData,
          isFetching: false,
          isFetched: true,
          failure: true
        });
      }
    );

    if (resCommentId) {
      setPostData({
        ...postData,
        isFetching: false,
        isFetched: true,
        failure: false
      });
      await addNewComment(passText, resCommentId);
      setTextVal('');
    }
  }
  async function getApi() {
    setCommentData({
      ...commentData,
      isFetching: true
    });
    await commentGetApi(passAnyDocId)
      .then(res => {
        setCommentData({
          ...commentData,
          isFetching: false,
          isFetched: true,
          failure: false,
          data: res || []
        });
      })
      .catch(err => {
        setCommentData({
          ...commentData,
          isFetching: false,
          isFetched: true,
          failure: true
        });
      });
  }

  ///add comment func
  function addNewComment(passText, resCommentId) {
    const addNewData = [...commentData.data];
    let userDataStringified = localStorage.getItem('userData');

    let userInfo = null;
    if (userDataStringified) {
      userInfo = JSON.parse(userDataStringified);
    }

    if (userInfo) {
      addNewData.push({
        commentId: resCommentId,
        userId: userInfo?.id,
        userName: {
          firstName: userInfo?.name?.firstName,
          middleName: userInfo?.name?.middleName,
          lastName: userInfo?.name?.lastName
        },
        comment: passText,
        createdOn: moment().utc(true)
      });
      setCommentData({ ...commentData, data: addNewData });
    }
  }
  async function deleteComment({ commentId, index }) {
    const newData = [...commentData.data];
    const res = await commentDeleteApi(passAnyDocId, commentId).then(res => {
      newData.splice(index, 1);
      setCommentData({ ...commentData, data: newData });
    });
  }

  const scrollToBottom = () => {
    if (forScrollRef.current) {
      forScrollRef.current.scroll({
        top: 2000,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    if (showCommentBox) {
      setTimeout(() => {
        scrollToBottom();
      }, 100);
    }
  }, [data.length, isFailureAddingPost, isFetchingAddPost, showCommentBox]);

  useEffect(() => {
    if (passAnyDocId) getApi();
  }, [data.length, passAnyDocId]);
  return (
    <React.Fragment>
      <div className="">
        <div
          onClick={() => {
            // getApi();
            setShowCommentBox(!showCommentBox);
          }}
          className={`flex border m-3 bg-white border-blue-1102 rounded px-1 py-1 px-2 py-2 cursor-pointer hover:shadow`}
          style={{
            width: 'fit-content'
          }}
        >
          <ChatBubbleOutlineIcon
            style={{ color: '#545454', maxWidth: '20px' }}
          />
          <span
            className={`font-roboto font-normal text-sm text-black-400  mx-2 `}
          >
            {data?.length}
            <span className="pl-1">Comment</span>
          </span>
        </div>
        {showCommentBox && (
          <div
            ref={commentContainerRef}
            style={styleCommentBox}
            className={`${commentBox} shadow p-2 m-6 mt-0`}
          >
            <div className="flex flex-col">
              <div
                className="close self-end cursor-pointer"
                onClick={() => setShowCommentBox(false)}
              >
                <img src={Close_icon} alt="" />
              </div>
              <div>
                <div
                  ref={forScrollRef}
                  className={`${styleScroll}  commentViewSection overflow-y-auto overflow-x-hidden my-3 pr-3`}
                >
                  {data.length === 0 && !failure && (
                    <div className={` flex mt-10  text-lg justify-center`}>
                      <span>No Comments Yet</span>
                      <img src={smileyEmoji} alt="" className="w-6 h-6 ml-2" />
                    </div>
                  )}

                  {data.map((each, index) => {
                    return (
                      <CommonTextArea
                        key={each.id}
                        each={each}
                        commentId={each.commentId}
                        index={index}
                        deleteComment={deleteComment}
                      />
                    );
                  })}
                  {isFetching && (
                    <div className="text-center mt-10">
                      <CircularProgress />
                    </div>
                  )}
                  {failure && (
                    <div className="text-center text-red-500 mt-10">
                      Something went wrong
                    </div>
                  )}
                  {isFetchingAddPost && (
                    <div className="text-center">
                      <CircularProgress size={20} />
                    </div>
                  )}
                  {isFailureAddingPost && (
                    <div className="text-center text-red-500">
                      Something went wrong
                    </div>
                  )}
                </div>
              </div>
              <CommonTextArea
                onlyWrite
                textVal={textVal}
                setTextVal={setTextVal}
                addNewComment={addNewComment}
                onClickCTA={() => {
                  if (textVal) {
                    postApi(textVal);
                  }
                }}
              />
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default CommonComment;
